import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Users,
  Team,
  CreateUserRequestInput,
  TicketInput,
  AccessRequestInput,
} from "../models/API";
import { Grid } from "@mui/material";
import { generateClient } from "aws-amplify/api";
import { createUserRequest, processTicketyEvents } from "../graphql/mutations";

interface RequestAccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (item: Users) => void;
  currentUserId: number;
  initialData: Team[];
  currentUserName: string;
}

const RequestAccessDialog: React.FC<RequestAccessDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  currentUserId,
  initialData,
  currentUserName,
}) => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [teams, setTeams] = useState<Team[] | null>([]);
  const client = generateClient();

  useEffect(() => {
    setTeams(initialData);
  }, [initialData]);

  if (!isOpen || !teams) {
    return null;
  }

  const handleRadioChange = (id: number) => {
    setSelectedId(id);
  };

  function getTeamName(team_id: number): string {
    const team = teams!.find((item) => item.id === team_id);
    return team!.name;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    if (selectedId === null) {
      return;
    }

    try {
      console.log("element=" + selectedId + ", user_id = " + currentUserId);
      const input: CreateUserRequestInput = {
        user_id: currentUserId,
        team_id: selectedId,
      };
      await client.graphql({
        query: createUserRequest,
        variables: {
          input: input,
        },
      });
      const accessRequest: AccessRequestInput = {
        appPrefix: "WeblabUI",
        ticketOwner: "UI",
        severity: "SEV_3",
        userName: currentUserName,
        teamName: getTeamName(selectedId),
        reason: "New user onboarding",
      };
      const simInput: TicketInput = {
        accessRequest: accessRequest,
      };
      await client.graphql({
        query: processTicketyEvents,
        variables: {
          input: simInput,
        },
      });
    } catch (err) {
      console.error(err);
    }
    handleClose();
  };
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Request Access</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {teams.map((team: Team, index: any) => (
              <div key={team.id}>
                <label>
                  <input
                    type={"radio"}
                    name="teamSelection"
                    value={team.id}
                    checked={selectedId === team.id}
                    onChange={() => handleRadioChange(team.id)}
                  />
                  - {team.name}
                </label>
                <br />
              </div>
            ))}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={selectedId === null}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestAccessDialog;
